import * as icons from "lucide-react";
import type { ServiceData } from "@/types/services";

interface ApiService extends Omit<ServiceData, "icon" | "title" | "description"> {
  slug: string;
  icon: string;
  title: string;
  description: string;
}

const baseUrl = (import.meta.env.VITE_API_BASE_URL || "http://localhost:8000").replace(/\/+$/, "");
const iconFor = (name: string) => (icons as unknown as Record<string, ServiceData["icon"]>)[name] || icons.Settings;
const mapService = (service: ApiService): ServiceData => ({ ...service, id: service.slug || service.id, icon: iconFor(service.icon) });

async function request<T>(path: string): Promise<T> {
  const response = await fetch(`${baseUrl}/v1${path}`, { headers: { Accept: "application/json" } });
  if (!response.ok) throw new Error(response.status === 404 ? "Service not found" : "Could not load services");
  return response.json();
}

export const fetchServices = async (language: string) => (await request<ApiService[]>(`/services?lang=${encodeURIComponent(language)}`)).map(mapService);
export const fetchService = async (slug: string, language: string) => mapService(await request<ApiService>(`/services/${encodeURIComponent(slug)}?lang=${encodeURIComponent(language)}`));
